'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosLoop = function IoIosLoop(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm38.3 20l0.9 0.9-4.1 4.1-4.1-4.1 0.8-0.9 3.3 3.2z m-2.2 0c0 0.5 0 1.1-0.1 1.6l-1.2 0c0-0.6 0-1.1 0-1.7 0-8-6.6-14.6-14.7-14.6-5.3 0-10.2 2.9-12.8 7.5l-1.1-0.6c2.8-5 8.2-8.1 13.9-8.1 8.8 0 15.9 7.1 16 15.7v0.2z m-3.1 7.2l1 0.6c-2.8 5-8.1 8.1-13.9 8.1-8.6 0-15.7-7-15.9-15.6v-0.3c0-0.5 0-1.1 0.1-1.6l1.2 0c0 0.6 0 1.1 0 1.7 0 8 6.6 14.6 14.6 14.6 5.4 0 10.3-2.9 12.9-7.5z m-27.9-12.2l4.1 4.1-0.9 0.9-3.2-3.2-3.2 3.2-0.9-0.9z' })
        )
    );
};

exports.default = IoIosLoop;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-loop.js
// module id = 2231
// module chunks = 0